import React, { useEffect, useState } from 'react';
import moment from 'moment';
import axios from 'axios';

import i18n from '../i18n';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';

import '../css/InternalComments.css';

import { statuses } from './statuses';
import IndpNewTask from './IndpNewTask';
import { urgencies } from './urgencies';
import CommentModal from './CommentModal';
import CommentSection from './CommentSection';
import CommonCustomToaster from './CommonCustomToaster';

const InternalComments = ({ 
    jwt, 
    api_url, 
    user_id, 
    user_name, 
    agentList, 
    element_id, 
    elementData, 
    element_type, 
    internalComments, 
    getInternalComments
}) => {

    const [message, setMessage] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState();
    const [showToaster, setShowToaster] = useState(false);
    const [singleComment, setSingleComment] = useState(false);
    const [openCommentModal, setOpenCommentModal] = useState(false);

    const openComment = (e, comment) => {
        setSingleComment(comment);

        if(selectedAgent !== undefined || selectedAgent != 'n/a'){
            setOpenCommentModal(true);
        }else{
            alert("Please select a agent");
        }
    }

    const handleClose = () => {
        setOpenCommentModal(false);
    };

    

    return(
        <>
            <div className="">
                <div className="row">
                    <div className="col-md-12">
                        <div className="chat-history">
                            <div className="card">
                                <div className="card-header">
                                    {/* <i className="fa fa-comments-o" aria-hidden="true"></i> */}
                                    <em className="com-icon"><img src="/newDesigning/images/comment-icon.svg" alt="comment-icon" /></em>
                                    <Trans>INTERNAL COMMENT HISTORY</Trans>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card-body">
                                            <div className="card-body-header comments-section">
                                                <CommentSection internalComments={internalComments} openComment={openComment} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <IndpNewTask 
                                            jwt={jwt}
                                            indp_call={false}
                                            user_id={user_id}
                                            api_url={api_url}
                                            user_name={user_name}
                                            agent_list={agentList}
                                            element_id={element_id}
                                            element_data={elementData}
                                            element_type={element_type}
                                            get_internal_comments={getInternalComments}
                                        />
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openCommentModal 
            ?

                <CommentModal
                    jwt={jwt}
                    status={statuses}
                    api_url={api_url}
                    user_id={user_id}
                    urgency={urgencies}
                    agentList={agentList}
                    open={openCommentModal} 
                    comment={singleComment}
                    handleClose={handleClose}
                    selectedAgent={selectedAgent} 
                    getInternalComments={getInternalComments}
                />

            : "" }

            {showToaster ?
                <CommonCustomToaster headContent={message} />
            : ""}
            
        </>
    );
}

export default withTranslation()(InternalComments);